<div *ngIf="languages" class="w-100">
    <p-dropdown
        [options]="languages"
        [ngModel]="selectionModel.selected[0]"
        (ngModelChange)="onChange($event)"
        [filter]="true"
        optionLabel="name"
        optionValue="isoCode"
        filterBy="name"
        [showClear]="true"
        [placeholder]="placeholder"
        styleClass="w-100"
    >
        <!--        <ng-template pTemplate="selectedItem" let-selectedOption>-->
        <!--            <div *ngIf="selectedOption" class="flex align-items-center gap-2">-->
        <!--                <div>{{ selectedOption.name }}</div>-->
        <!--            </div>-->
        <!--        </ng-template>-->
        <!--        <ng-template let-country pTemplate="item">-->
        <!--            <div *ngIf="country" class="flex align-items-center gap-2">-->
        <!--                <div>{{ country.name }}</div>-->
        <!--            </div>-->
        <!--        </ng-template>-->
    </p-dropdown>
</div>
